import { environment as EqualtimeEnv } from './BaseEnvironments/Equaltime';
function Env() {
  var env: any = EqualtimeEnv;
  env.apiUrl= 'https://www.equaltimeonlus.eu/api';
  return env;
}
export const environment = Env();
